import { render, staticRenderFns } from "./remindReceive.vue?vue&type=template&id=572263d4&scoped=true"
import script from "./remindReceive.vue?vue&type=script&lang=ts"
export * from "./remindReceive.vue?vue&type=script&lang=ts"
import style0 from "./remindReceive.vue?vue&type=style&index=0&id=572263d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572263d4",
  null
  
)

export default component.exports